module.exports = __webpack_public_path__ + "img/help-icon.e578baf0.svg";